
export const GOOGLE_ADWORDS_ID= '975074101';
export const FACEBOOK_PIXEL_ID = '563600790470964';
